import { QuantityCalculator } from './quantityCalculator';
import { last, first } from '../../commons/utils';
export function selectProductOptionItems(product) {
    return product.options;
}
export function selectProductOptionItemsByType(product, type) {
    return product.options.find(function (o) { return o.optionType === type; });
}
export function inStock(product, variant) {
    var ref = variant || product;
    if (product.isTrackingInventory) {
        if (variant) {
            return ref.inventory.quantity > 0;
        }
        return product.inventory.quantity > 0 || product.productItems.some(function (item) { return item.inventory.quantity > 0; });
    }
    return ref.inventory.status === "in_stock" /* IN_STOCK */;
}
export function userInputsFactory() {
    return { selection: [], text: [], quantity: [] };
}
export function validateUserInputs(product, userInputs) {
    var errors = userInputsFactory();
    var quantityRange = QuantityCalculator.getQuantitiesRange(product, userInputs.selection);
    var userQuantity = Number(userInputs.quantity[0]);
    product.options.reduce(function (acc, _, i) {
        acc.selection[i] = !userInputs.selection[i];
        return acc;
    }, errors);
    if (product.customTextFields) {
        product.customTextFields.reduce(function (acc, item, i) {
            acc.text[i] = item.isMandatory === true && !userInputs.text[i];
            return acc;
        }, errors);
    }
    errors.quantity = [
        (isNaN(userQuantity) || userQuantity < first(quantityRange) || userQuantity > last(quantityRange)) === true,
    ];
    return errors;
}
export function formatCustomTextFields(product, userInputs) {
    var customTextFields = [];
    return (product.customTextFields || []).reduce(function (acc, field, i) {
        acc.push({
            customText: { title: field.title },
            answer: userInputs.text[i] || '',
        });
        return acc;
    }, customTextFields);
}
export function hasVariantInStock(product) {
    return product.productItems.some(function (option) { return inStock(product, option); });
}
//# sourceMappingURL=producUtils.js.map